import { FETCH_BALANCE, FETCH_BALANCE_SUCCESS, FETCH_BALANCE_FAILURE, SAVE_BALANCE_SUCCESS,
  SAVE_BALANCE_FAILURE, DELETE_BALANCE_SUCCESS, DELETE_BALANCE_FAILURE, BALANCE_AJAX_CALL,
  BALANCE_CLEAR_AJAX_CALL, BALANCE_START_UPLOAD, BALANCE_STOP_UPLOAD } from '../actions/Balance'

const initialState = {
  list: null,
  error: null,
  loading: false,
  ajaxSpinner: false,
  ajaxStatus: null,
  uploading: false
}

export default function balance (state = initialState, action) {
  switch (action.type) {
    case FETCH_BALANCE:
      return {...state, loading: true, error: null, list: null}
    case FETCH_BALANCE_SUCCESS:
      return {...state, list: action.payload, loading: false, error: null}
    case FETCH_BALANCE_FAILURE:
      return {...state, error: action.payload, loading: false, list: null}
    case SAVE_BALANCE_SUCCESS:
      return {...state,
        list: ((state.list.findIndex(x => x.id === action.payload.id) === -1)
          ? state.list.concat(action.payload)
          : state.list.map((item) => {
            return (item.id === action.payload.id) ? action.payload : item
          })).sort((a, b) => {
          return (a.emission_date < b.emission_date) ? 1 : ((b.emission_date < a.emission_date) ? -1 : 0)
        }),
        ajaxStatus: null,
        ajaxSpinner: false}
    case SAVE_BALANCE_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case DELETE_BALANCE_SUCCESS:
      return {...state,
        list: state.list.filter((item) => {
          return item.id !== action.payload
        }),
        ajaxStatus: null,
        ajaxSpinner: false}
    case DELETE_BALANCE_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case BALANCE_AJAX_CALL:
      return { ...state, ajaxSpinner: true, ajaxStatus: null }
    case BALANCE_CLEAR_AJAX_CALL:
      return { ...state, ajaxSpinner: false, ajaxStatus: null }
    case BALANCE_START_UPLOAD:
      return { ...state, uploading: true }
    case BALANCE_STOP_UPLOAD:
      return { ...state, uploading: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/balance.js